import { Sparkles } from 'lucide-react';
import { IFeedItem } from '@/redux/feed/feed.d';
import { MiniCard } from './cards';

export default function FeaturedStrip({ items }: { items: IFeedItem[] }) {
  if (items.length === 0) return null;

  return (
    <div className="mt-8">
      <div className="mb-3 flex items-center gap-2">
        <h2 className="font-display text-2xl font-bold text-heading">
          More featured designs
        </h2>
        <Sparkles className="h-5 w-5 text-green-600" />
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((item) => (
          <MiniCard key={`${item.type}-${item._id}`} item={item} />
        ))}
      </div>
    </div>
  );
}
